import React, { FC, FormEvent } from "react";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";

import {
  useInput,
  useDropdown,
  useProvidersCurrentEmployee,
  useApisManagersBusinessSectionsEdit,
  useApisManagersBusinessSectionsUpdate,
  useMultipleDropdown,
} from "~/hooks";

import {
  Form,
  FormSubmitButton,
  LabelWithTextField,
  LabelWithDropDownField,
  LabelWithMultipleDropdownField,
} from "~/ui";

type PropsType = {
  businessSectionId: string;
};

export const BusinessSectionEditForm: FC<PropsType> = ({
  businessSectionId,
}) => {
  const navigate = useNavigate();
  const { refetch } = useProvidersCurrentEmployee();

  const [
    { value: businessSectionName, onChange: onChangeBusinessSectionName },
    setBusinessSectionName,
  ] = useInput("");
  const [
    {
      dropdownValue: selectedCurrentDivisionManagers,
      onChange: onChangeCurrentDivisionManagers,
      dropdownSelectableValue: selectableCurrentDivisionManagers,
      setSelectableOption: setSelectableCurrentDivisionManagers,
    },
  ] = useMultipleDropdown();

  const [
    {
      dropdownValue: selectedBusinessDivision,
      onChange: onChangeBusinessDivision,
      handleSetSelectableOption: handleSetSelectableOption,
      dropdownSelectableValue: selectableBusinessDivisions,
    },
    setBusinessDivisionDropdown,
  ] = useDropdown();

  const { isError } = useApisManagersBusinessSectionsEdit({
    id: businessSectionId,
    config: {
      onSuccess: (data) => {
        setBusinessSectionName(data.businessSection.name);
        setBusinessDivisionDropdown(data.businessSection.businessDivision);
        handleSetSelectableOption(data.selectableBusinessDivisions);
        onChangeCurrentDivisionManagers(
          data.currentSectionManagers.map((manager) => ({
            label: manager.name,
            value: manager.id,
          })),
        );
        setSelectableCurrentDivisionManagers(
          data.sectionEmployees.map((employee) => ({
            name: employee.name,
            id: employee.id,
          })),
        );
      },
    },
  });

  const { mutate: updateRequest, isLoading: isSubmitting } =
    useApisManagersBusinessSectionsUpdate();

  if (isError) {
    return null;
  }

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const body = {
      name: businessSectionName,
      businessDivisionId: selectedBusinessDivision?.value || "",
      managerEmployeeIds: selectedCurrentDivisionManagers?.map(
        (manager) => manager.value,
      ),
    };
    updateRequest(
      {
        body,
        id: businessSectionId,
      },
      {
        onSuccess: (data) => {
          navigate("/managers/business_sections");
          toast(data.message);
          refetch();
        },
      },
    );
  };

  return (
    <Form onSubmit={handleSubmit} className="space-y-6">
      <LabelWithTextField
        labelText="課名"
        type="text"
        name="businessSection"
        required
        placeholder="課名"
        value={businessSectionName}
        onChange={onChangeBusinessSectionName}
      />
      <LabelWithDropDownField
        labelText="部署"
        required
        name="businessDivisions"
        options={selectableBusinessDivisions}
        value={selectedBusinessDivision}
        onChange={onChangeBusinessDivision}
      />
      <LabelWithMultipleDropdownField
        labelText="課マネージャー"
        name="currentSectionManagers"
        options={selectableCurrentDivisionManagers}
        value={selectedCurrentDivisionManagers}
        onChange={onChangeCurrentDivisionManagers}
      />
      <FormSubmitButton
        color="primary"
        value="保存"
        className="w-full"
        isReadOnly={isSubmitting}
      />
    </Form>
  );
};
